import React, { useEffect } from 'react';
import { useAnalytics } from '../analytics';
import { onPaneLoadComplete } from '../analytics/events';
export const TimeLazyLoad = ({
  children,
  product
}) => {
  const {
    fireAnalyticsEvent
  } = useAnalytics();
  useEffect(() => {
    const start = Date.now();
    return () => {
      fireAnalyticsEvent(onPaneLoadComplete(product, Date.now() - start));
    };
  }, [fireAnalyticsEvent, product]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, children);
};